import { Item, ItemProps } from "./item/Item";
import styles from "./Miscellaneous.module.scss";

export type MiscellaneousProps = {
  title: string;
  items: ItemProps[];
};
export const Miscellaneous = ({ title, items }: MiscellaneousProps) => {
  return (
    <div className={styles.miscellaneous}>
      <p className={styles.title}>{title}</p>
      {items.map((item, index) => (
        <Item {...item} key={index} />
      ))}
    </div>
  );
};
